const labels = {
  /* Header */
  crm_collaborators: 'CRM Collaborateurs',
  collaborators: 'Collaborateurs',
  add_collaborator: 'Ajouter Collaborateur',
  add_group: 'Ajouter Groupe',
  search: 'Recherche',
  /* **************************************************** */
  /* Collaborators table  */
  digital_account: 'Compte digital',
  name: 'Nom',
  phone: 'Mobile',
  email: 'Email',
  lastname: 'Nom de famille',
  registration_number: "Numéro d'enregistrement",
  /* **************************************************** */
  /* Generic */
  save: 'Enregistrer',
  cancel: 'Annuler',
  edit: 'Éditer',
  back: 'Retour',
  continue: 'Continuez',
  all: 'Tout',
  clean: 'Effacer',
  yes: 'Oui',
  no: 'Non',
  loading: 'Chargement en cours',
  delete: 'Effacer',
  active: 'Actif',
  check_fields: 'Vérifier les champs',
  table_no_data: 'Pas de données disponibles',
  error_occurred: 'Une erreur est survenue',
  date_start: 'Date début',
  date_end: 'Date fin',
  external_access: 'Accès Externe',
  /* **************************************************** */
  /* Manage Collaborator */
  collaborator: 'Collaborateur',
  new_collaborator: 'Nouveau collaborateur',
  collaborator_not_found: 'Collaborateur non trouvé',
  birthday: 'Date de naissance',
  edit_collaborator: 'Modifier le collaborateur',
  collaborator_saved: 'Collaborateur enregistré',
  create_collaborator: 'Créer un nouveau collaborateur',
  collaborator_profile: 'Profil Collaborateur',
  assigns: 'Ayant Droits',
  ressources: 'Ressources',
  contracts: 'Contrats',
  habilitations: 'Habilitations',
  no_restrictions: 'Pas de restrictions',
  no_groups: "Il n'y a pas de groupes",
  app_access: "Accès à l'application",
  recruiter_permissions: 'Autorisations du recruteur',

  /* Applications */
  admin_application: 'ADMIN (Access to all applications)',
  speedboat_application: 'PIM SpeedBoat',
  alpha_application: 'PIM Alpha',
  labalaguere_application: 'PIM La Balaguère',
  crm_application: 'CRM Clients',
  collaborator_application: 'CRM Employees',
  merch_application: 'Merch',
  equestrian_application: 'Pegasus',
  iresa_search_application: 'Search iResa Products',
  iresa_search_labalaguere_producers_application: 'Search Iresa LaBalaguere Producers',
  iresa_search_labalaguere_telesales_application: 'Search Iresa LaBalaguere Telesales',
  alpha_impersonate_mode_application: 'Alpha Impersonate Mode',
  alpha_contract_management_application: 'Alpha Contract Management',
  alpha_contract_end_date_update_application: 'Alpha Contract End Date Update',
  alpha_court_application: 'Alpha Court',
  speedboat_impersonate_mode_application: 'Speedboat Impersonate Mode',
  labalaguere_impersonate_mode_application: 'Labalaguere Impersonate Mode',
  kala_application: 'KALA Dashboard',
  ucpa_anonymize_application: 'UCPA Anonymize',
  legacy_api_calls_application: 'Legacy API Calls',
  hello_application: 'Hello Dashboard',
  talent_application: 'PIM Talent',
  recruiter_application: 'CRM Recruiter',
  target_application: 'Target Dashboard',
  target_vacances_application: 'Target Vacances Dashboard',
  target_loisirs_application: 'Target Loisirs Dashboard',
  crm_interactions_reader_application: 'CRM Interactions Reader',
  crm_interactions_writer_application: 'CRM Interactions Writer',

  dashboard_transport_application: 'Dashboard Transport', // TO REMOVE

  companion_dashboard_application: 'Companion Dashboard',
  companion_myplanning_application: 'Companion Planning',

  /* **************************************************** */

  /* Manage Recruiter */
  recruiter_all_permissions: 'Accorder un accès complet à toutes les fonctionnalités de l’espace recruteur.',

  /* Manage Group */
  groups: 'Groupes',
  group: 'Groupe',
  new_group: 'Nouveau groupe',
  create_group: 'Créer un nouveau groupe',
  restrictions: 'Restrictions',
  create_restriction: 'Créer une restriction',
  delete_restriction_question: 'Supprimer la restriction?',
  error_deleting_restriction: "Une erreur s'est produite lors de la suppression des restrictions",
  restriction_deleted: 'Restriction supprimée.',
  permission: 'Autorisation',
  workspaces_permissions: 'Autorisations des espaces de travail',
  permission_read_all: 'Autorisation de lire à partir de tous les espaces de travail',
  permission_write_all: "Autorisation d'écrire à partir de tous les espaces de travail",
  default: 'Défaut',
  roles: 'Les rôles',
  edit_permissions: 'Modifier les autorisations',
  create_permission: 'Créer une nouvelle autorisation',
  project: 'Projet',
  permission_saved: 'Autorisation enregistrée.',
  permission_not_saved: "L'autorisation n'a pas pu être enregistrée.",
  all_workspaces: 'Tous les espaces de travail',
  permission_type: "Type d'autorisation",
  content_types: 'Types de contenu',
  workspaces: 'Espaces de travail',
  workspace: 'Espace de travail',
  all_values: 'Toutes les valeurs',
  all_content_types: 'Tous les types de contenu',
  restriction_edited: 'Restriction modifiée',
  restriction_created: 'Restriction créée',
  values: 'Valeurs',
  reset_password: 'Réinitialiser le mot de passe',
  reset_password_request_sent: 'Un message a été envoyé au collaborateur pour réinitialiser le mot de passe.',
  error_occured: "Une erreur s'est produite",
  reset_password_question: "Voulez-vous envoyer un message à l'utilisateur pour réinitialiser le mot de passe?",
  list_collaborators: 'Liste des collaborateurs',
  permissions: 'Autorisations',
  actions: 'Actions',
  selection_mode: 'Mode de selection',
  edit_group: "Groupe d'édition",
  group_not_found: 'Groupe introuvable',
  group_saved: 'Groupe enregistré',
  group_updated: 'Groupe mis à jour avec succès',
  remove_collaborator_group_question: 'Voulez-vous supprimer ce collaborateur du groupe?',
  collaborator_removed_group: 'Collaborateur supprimé du groupe',
  collaborator_added_group: 'Le collaborateur a été ajouté au groupe',
  collaborator_add_group_error: "Une erreur s'est produite lors de l'ajout du collaborateur au groupe",
  collaborator_remove_group_error: "Une erreur s'est produite lors de la suppression du collaborateur du groupe",
  restriction_removed_group: 'Restriction supprimée du groupe',
  restriction_changed_successfully: 'Restriction modifiée avec succès',
  description: 'La description',
  delete_group_question: 'Voulez-vous vraiment supprimer ce groupe?',
  delete_collaborator_question: 'Voulez-vous vraiment supprimer ce collaborateur?',
  collaborator_deleted: 'Le collaborateur a été supprimé avec succès.',
  group_deleted: 'Le groupe a été supprimé avec succès',
  phone_or_email_required_error: 'Vous devez insérer un numéro de téléphone ou un email',
  delete_collaborator: 'Supprimer un collaborateur',
  delete_warning: 'Attention, cette action est irréversible',
  delete_group: 'Supprimer le groupe',
  collaborator_in_group_error: 'Ce collaborateur est déjà dans le groupe',
  limited_contents: 'Contenu limité',
  create_resource: 'Créer une ressource',
  resource_type: 'Type de ressource',
  resource_updated: 'Ressources mises à jour avec succès',
  error_updating_resource: "Une erreur s'est produite lors de la mise à jour des ressources",
  updated_app_access: 'Les accès aux applications ont été mis à jour',
  error_updating_app_access: "Une erreur s'est produite lors de la mise à jour des accès à l'application",
  updated_external_access: "L'accès externe a été mis à jour",
  error_updating_external_access: "Une erreur s'est produite lors de la mise à jour de l'accès externe",
  contract_id: 'Id contrat',
  contract_type: 'Type de contrat',
  code_establishment: 'Code établissement',
  contracts_updated: 'Contrats mis à jour avec succès',
  extra_building_codes: 'Codes établissement supplémentaires',
  company: 'Société',
  establishment: 'Etablissement',
  job: 'Emploi',
  /* Restrictions */
  SELECT_PERMISSION: 'Sélectionnez les autorisations',
  SELECT_WORKSPACES: 'Sélectionnez les espaces de travail',
  SELECT_CONTENT_TYPES: 'Sélectionnez les types de contenu',
  SELECT_CONTENTS: 'Sélectionnez Contenu',
  CONFIRMATION: 'Confirmation',

  show_only_content_types: "Autoriser l'accès à certains types de contenus de niveau \"objet\"",
  restrict_content_types: "Restreindre l'accès à certains types de contenus de niveau \"objet\"",
  show_only_contents: "Autoriser l'accès à certains contenus de niveau \"variables spécifiques d'objet\"",
  hide_contents: "Restreindre l'accès à certains contenus de niveau \"variables spécifiques d'objet\"",
  show_calendar: 'Show Calendar',

  no_contents_error: "Il n'y a pas de contenu avec les espaces de travail sélectionnés et les types de contenu en commun",
  insert_minimum_content_types: 'Insérer au moins un type de contenu',
  insert_minimum_content: 'Insérer au moins un contenu',
  insert_minimum_workspace: 'Insérer au moins un espace de travail',
  add_collab_to_search: 'Ajouter à la recherche',
  add_collab_to_hello: 'Ajouter à la groupe',
  /* **************************************************** */
  /* rules */

  /* **************************************************** */
  labels: 'Labels',

  /* **************************************************** */
  /* API Messages */

  'Collaborator already exists with that email, mobilephone or employee number': "Le collaborateur existe déjà avec cet e-mail, ce téléphone portable ou ce numéro d'employé"
  /* **************************************************** */
};

export { labels };
